import PropTypes from "prop-types";
import { MenuItem, TextField } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

export default function EventosMobile({ filas, orden, setOrden }) {
  return (
    <SoftBox px={2} pb={2}>
      <TextField select fullWidth size="small" label="Ordenar eventos" value={`${orden.campo}-${orden.orden}`}
        onChange={(e) => {
          const [campo, direccion] = e.target.value.split("-");
          setOrden({ campo, orden: direccion });
        }} sx={{ mb: 2 }}>
        <MenuItem value="inicio-DESC">Inicio: más recientes primero</MenuItem>
        <MenuItem value="inicio-ASC">Inicio: más antiguos primero</MenuItem>
        <MenuItem value="fin-DESC">Fin: más recientes primero</MenuItem>
        <MenuItem value="fin-ASC">Fin: más antiguos primero</MenuItem>
        <MenuItem value="nombre-ASC">Nombre: A a Z</MenuItem>
        <MenuItem value="nombre-DESC">Nombre: Z a A</MenuItem>
      </TextField>
      <SoftBox display="grid" gap={1.5}>
        {filas.map((fila) => (
          <SoftBox key={fila.id} p={2} borderRadius="lg" sx={{ border: "1px solid #e9ecef", minWidth: 0 }}>
            <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" gap={1}>
              <SoftBox minWidth={0}>{fila.nombre}</SoftBox>
              <SoftBox flexShrink={0}>{fila.accion}</SoftBox>
            </SoftBox>
            <SoftBox mb={1}>{fila.estado}</SoftBox>
            {[["Inicio", fila.inicio], ["Fin", fila.fin], ["Menú universitario", fila.menu], ["Autogestión", fila.autogestion]].map(([label, contenido]) => (
              <SoftBox key={label} display="flex" flexDirection="column" mb={0.5}>
                <SoftTypography variant="caption" color="secondary">{label}</SoftTypography>
                {contenido}
              </SoftBox>
            ))}
          </SoftBox>
        ))}
      </SoftBox>
    </SoftBox>
  );
}

EventosMobile.propTypes = {
  filas: PropTypes.array.isRequired,
  orden: PropTypes.object.isRequired,
  setOrden: PropTypes.func.isRequired,
};
